
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import PropertyList from './pages/PropertyList';
import Footer from './components/Footer';
import TermsAndConditions from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import ListingPage from './pages/ListingPage';
import CheckoutPage from './pages/CheckoutPage';



function App() {
  return (
   <BrowserRouter>
    <Header/>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/properties' element={<PropertyList/>} />
      <Route path="/property/:title" element={<ListingPage />} />
      <Route path='/checkout' element={<CheckoutPage/>} />
      <Route path='privacy-policy' element={<PrivacyPolicy/>} />
      <Route path='terms' element={<TermsAndConditions/>} />
      <Route path='about' element={<Home/>} />
      <Route path='cookies' element={<Home/>} />
    </Routes>
    <Footer/>
   </BrowserRouter>
  );
}

export default App;
